"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHaveSharedParentDomain = getHaveSharedParentDomain;
function getHaveSharedParentDomain(params) {
    var url1 = params.url1, url2 = params.url2;
    var url1Domain = new URL(url1).hostname;
    var url2Domain = new URL(url2).hostname;
    var getLevel2Domain = function (url) {
        var parts = url.split(".");
        return parts.slice(parts.length - 2).join(".");
    };
    return getLevel2Domain(url1Domain) === getLevel2Domain(url2Domain);
}
//# sourceMappingURL=haveSharedParentDomain.js.map